import { render, staticRenderFns } from "./MemberAnnualFeeReport.vue?vue&type=template&id=63550807&scoped=true&"
import script from "./MemberAnnualFeeReport.vue?vue&type=script&lang=js&"
export * from "./MemberAnnualFeeReport.vue?vue&type=script&lang=js&"
import style0 from "./MemberAnnualFeeReport.vue?vue&type=style&index=0&id=63550807&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63550807",
  null
  
)

export default component.exports